import React, { useEffect, useState } from 'react'
import TextFieldUniversal from '../../../../validate/form/text/TextFieldUniversal'
import { useSelector } from 'react-redux'
// import { unitMeasureShortText } from '../../../../../helpers/unitMeasure/UnitMeasureHelper'

const WriteOffActItemCountField = ({ item, addedWriteOff, data, required, setValidate, setValueForm, forciblyValue }) => {

	const unitMeasures = useSelector(state => state.settings.unitMeasures)
    const unitMeasure = unitMeasures && unitMeasures[item.unitMeasure] ? unitMeasures[item.unitMeasure].name : '?'

	const [value, setValue] = useState('')
	const [forciblyError, setForciblyError] = useState('')
	const [countForWriteOffTemp, setCountForWriteOffTemp] = useState(item.countForWriteOff)

	useEffect(() => {
		checkValidCount()
	}, [item, addedWriteOff, data])

	const checkValidCount = () => {
		// Якщо зміна кількості, то до загальної додаєму ту, що вже вказана в позиції
		const countForWriteOff = item.countForWriteOff + addedWriteOff 
		setCountForWriteOffTemp(countForWriteOff)

        if (data.count > countForWriteOff) {
			setForciblyError('Значення не може бути більше за загальну кількість')
		} else {
			setForciblyError('')
		}
    }

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Кількість'} 
        placeholder={'1'}
        validates={{
            isEmpty: true,
            // isDigit: true
            isNumber: true
        }}
        forciblyValue={forciblyValue}
        required={required}
		forciblyError={forciblyError}
        // classNameAdd={'w200'}
		InputProps={{
			endAdornment: 
				// <span sx{{}}='white-space: nowrap;'>
				<span 
					style={{
						whiteSpace: 'nowrap'
					}}
				>
					{/* {`з ${item.countForWriteOff} ${unitMeasureShortText[item.unitMeasure]}`} */}
					{/* {`з ${countForWriteOffTemp} ${unitMeasureShortText[item.unitMeasure]}`} */}
					{`з ${countForWriteOffTemp} ${unitMeasure}`}
				</span>,
		}}
    />
  )
}

export default WriteOffActItemCountField